import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { KeyCapProps } from './types.js';

/** `<KeyCap>` component. */
export const KeyCap = ({ className, glyph, ...props }: KeyCapProps): ReactElement => (
  <div
    className={twMerge(
      'grid h-28 select-none place-items-center rounded-4 border-3/2 border-muted bg-base-100 text-md text-muted',
      glyph.length === 1 ? 'aspect-square' : 'px-6',
      className
    )}
    {...props}
  >
    {glyph}
  </div>
);
